export type TagVariant = 'image' | 'document' | 'video' | 'multi' | 'text' | 'regular' | 'reel';

export const tagStyles: Record<TagVariant, { bg: string; text: string; border: string }> = {
  image: { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-100' },
  document: { bg: 'bg-green-50', text: 'text-green-700', border: 'border-green-100' },
  video: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-100' },
  multi: { bg: 'bg-blue-100', text: 'text-blue-800', border: 'border-blue-200' },
  text: { bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-200' },
  regular: { bg: 'bg-purple-50', text: 'text-purple-700', border: 'border-purple-100' },
  reel: { bg: 'bg-pink-50', text: 'text-pink-700', border: 'border-pink-100' },
};

export const tagEmoji: Record<TagVariant, string> = {
  image: '🖼️',
  document: '📄',
  video: '🎬',
  multi: '🎞️',
  text: '📝',
  regular: '📸',
  reel: '📱',
};

// Function to get translated tag labels
export function getTagLabels(t: (key: string, fallback: string) => string): Record<TagVariant, string> {
  return {
    image: t('tags.image', 'Image'),
    document: t('tags.document', 'Document'),
    video: t('tags.video', 'Video'),
    multi: t('tags.multi', 'Multi-images'),
    text: t('tags.text', 'Text'),
    regular: t('tags.regular', 'Regular'),
    reel: t('tags.reel', 'Reel'),
  };
}

// Keep the old tagLabel for backward compatibility
export const tagLabel: Record<TagVariant, string> = {
  image: 'Image',
  document: 'Document',
  video: 'Video',
  multi: 'Multi-images',
  text: 'Text',
  regular: 'Regular',
  reel: 'Reel',
};

export function getMediaTagVariant(url?: string, type?: 'image' | 'video', isMulti?: boolean): TagVariant {
  if (isMulti) return 'multi';
  if (!url && !type) return 'text';
  if (url && /\.pdf(\?|#|$)/i.test(url)) return 'document';
  if (type === 'video') return 'video';
  if (type === 'image' || url) return 'image';
  return 'text';
}

// Normalize backend provided postMediaType to our TagVariant
export function normalizeBackendMediaType(raw?: string): TagVariant | undefined {
  if (!raw) return undefined;
  const v = raw.trim().toLowerCase().replace(/\s+/g, '-').replace(/_/g, '-');
  if (v === 'image' || v === 'photo' || v === 'picture') return 'image';
  if (v === 'video') return 'video';
  if (v === 'document' || v === 'pdf' || v === 'file') return 'document';
  if (v === 'text' || v === 'none') return 'text';
  if (
    v === 'multi' ||
    v === 'multi-image' ||
    v === 'multi-images' ||
    v === 'multiimage' ||
    v === 'multiimages' ||
    v === 'carousel' ||
    v === 'carousel-post' ||
    v === 'album'
  ) return 'multi';
  return undefined;
}


